import React from 'react';

export default function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-util/es/Children/toArray.js
// module id = 80
// module chunks = 0 1 2 3